// extracted by mini-css-extract-plugin
module.exports = {"buttons":"GenericError_buttons__2AOgF"};